// -----------------------------------------------------------
// @ EmployeeRole Actions
// -----------------------------------------------------------

import { createAction, props } from '@ngrx/store';
import { EmployeeRole } from './employee-roles.models';

// Load all
export const loadEmployeeRoles = createAction(
    '[EmployeeRole] Load EmployeeRoles'
);
export const loadEmployeeRolesSuccess = createAction(
    '[EmployeeRole] Load EmployeeRoles Success',
    props<{ roles: EmployeeRole[] }>()
);
export const loadEmployeeRolesFailure = createAction(
    '[EmployeeRole] Load EmployeeRoles Failure',
    props<{ error: string }>()
);

// Load one
export const loadEmployeeRole = createAction(
    '[EmployeeRole] Load EmployeeRole',
    props<{ id: number }>()
);
export const loadEmployeeRoleSuccess = createAction(
    '[EmployeeRole] Load EmployeeRole Success',
    props<{ role: any }>()
);
export const loadEmployeeRoleFailure = createAction(
    '[EmployeeRole] Load EmployeeRole Failure',
    props<{ error: string }>()
);

// Create
export const createEmployeeRole = createAction(
    '[EmployeeRole] Create EmployeeRole',
    props<{ data: string }>()
);
export const createEmployeeRoleSuccess = createAction(
    '[EmployeeRole] Create EmployeeRole Success',
    props<{ role: any; success: string }>()
);
export const createEmployeeRoleFailure = createAction(
    '[EmployeeRole] Create EmployeeRole Failure',
    props<{ error: string }>()
);

// Update
export const updateEmployeeRole = createAction(
    '[EmployeeRole] Update EmployeeRole',
    props<{ data: string; id: number }>()
);
export const updateEmployeeRoleSuccess = createAction(
    '[EmployeeRole] Update EmployeeRole Success',
    props<{ role: any; success: string }>()
);
export const updateEmployeeRoleFailure = createAction(
    '[EmployeeRole] Update EmployeeRole Failure',
    props<{ error: string }>()
);

// Delete
export const deleteEmployeeRole = createAction(
    '[EmployeeRole] Delete EmployeeRole',
    props<{ id: number }>()
);
export const deleteEmployeeRoleSuccess = createAction(
    '[EmployeeRole] Delete EmployeeRole Success',
    props<{ id: number; success: string }>()
);
export const deleteEmployeeRoleFailure = createAction(
    '[EmployeeRole] Delete EmployeeRole Failure',
    props<{ error: string }>()
);
